import { render, staticRenderFns } from "./RankChangeDefault.vue?vue&type=template&id=5a0ac84d&"
import script from "./RankChangeDefault.vue?vue&type=script&lang=js&"
export * from "./RankChangeDefault.vue?vue&type=script&lang=js&"
import style0 from "./RankChangeDefault.vue?vue&type=style&index=0&id=5a0ac84d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports